import { I18nOverrides } from '@ingestro/importer-react'

import i18n from 'modules/core/lib/i18n'

// You can find all the available keys at https://docs.getnuvo.com/sdk/multi-language/#i18noverrides
export const i18nOverrides = (isEdition: boolean): I18nOverrides => {
  const isEditionOverrides = {
    txt_complete_imports: i18n.t('universal_importer.nuvo_importer.edition_mode.complete_imports'),
    txt_confirm_title: i18n.t('universal_importer.nuvo_importer.leave_modal.title'),
    txt_go_back_dynamic_import_title: i18n.t('universal_importer.nuvo_importer.leave_modal.body'),
    txt_back: i18n.t('common.cancel'),
  }

  const baseOverrides = {
    txt_confirm_title_close_modal: i18n.t('universal_importer.nuvo_importer.leave_modal.title'),
    txt_close_page_modal: i18n.t('universal_importer.nuvo_importer.leave_modal.body'),
    txt_go_back_dynamic_import_title: i18n.t('universal_importer.nuvo_importer.leave_modal.body'),
    txt_positive_button_close_modal: i18n.t('universal_importer.nuvo_importer.leave_modal.exit'),
    txt_negative_button_close_modal: i18n.t('universal_importer.nuvo_importer.leave_modal.cancel'),
    txt_confirm_leave_confirm_btn: i18n.t('universal_importer.nuvo_importer.leave_modal.exit'),
    txt_confirm_leave_cancel_btn: i18n.t('universal_importer.nuvo_importer.leave_modal.cancel'),
    txt_back: i18n.t('common.back'),
    txt_select_header_desc: i18n.t('universal_importer.nuvo_importer.select_header.description'),
  }

  return {
    ...baseOverrides,
    ...(isEdition ? isEditionOverrides : {}),
  }
}
